import axios, { postJson, putJson } from '@dap/shared-utils/http.js';

export default {
    // 公共字典
    getDict: (params) => axios.get('/artascope/api/dict', { params }),
    // 飞书通讯录（组织架构）
    getFeishuContact: (params) => axios.get('/artascope/api/feishu/contact', { params }),
    // 飞书搜用户
    getFeishuSearchUser: (params) => axios.get('/artascope/api/feishu/search_user', { params }),
    // 飞书搜部门
    getFeishuSearchDepartment: (params) => axios.get('/artascope/api/feishu/search_department', { params }),
    // DAP供应商
    getSupplierContact: (params) => axios.get('/artascope/api/supplier/contact', { params }),
    // 重名校验
    checkName: (params) => postJson('/artascope/api/object/check_name', params),
    // 供应商列表
    getSupplierList: (params) => axios.get('/artascope/api/project/supplier', { params }),
    // 用户信息
    getUserInfo: (params) => axios.get('/artascope/api/user/info', { params }),
};
